<template>
  <vs-popup class="customer-sample-order-create-popup"
            title="SERVICE ORDER CREATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card id="popup" no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-order-popup" @submit.prevent="handleSubmit(onClickCreateServiceOrder)" autocomplete="off">
          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:mb-0">
              <vs-table :data="cartItems">
                <template slot="header">
                  <h3>
                  </h3>
                </template>
                <template slot="thead">
                  <vs-th width="15%">SERVICE NAME</vs-th>
                  <vs-th width="15%">CATEGORY</vs-th>
                  <vs-th width="15%">SERVICE DESCRIPTION</vs-th>
                  <vs-th width="15%">QUANTITY</vs-th>
                  <vs-th width="15%">UNIT PRICE (GBP)</vs-th>
                  <vs-th width="15%">VAT (GBP)</vs-th>
                  <vs-th width="15%">TOTAL Excl VAT (GBP)</vs-th>
                  <vs-th width="10%"></vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>

                    <vs-td :data="data[indextr].category">
                      {{ data[indextr].category }}
                    </vs-td>

                    <vs-td>
                      <ValidationProvider :vid="indextr+'description'" :name="indextr+'description'" rules="" v-slot="{ errors }">
                        <vs-textarea class="mb-0" v-model="data[indextr].description"  height="70px" />
                      </ValidationProvider>
                    </vs-td>

                    <vs-td :data="data[indextr].quantity">
                      <vs-input v-model="data[indextr].quantity" name="quantity" class="w-full" label=""
                                val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </vs-td>

                    <vs-td :data="data[indextr].unit_price">
                      <!-- {{ Number(data[indextr].unit_price).toFixed(2) }} -->
                      <vs-input v-model="data[indextr].unit_price" name="unit_price" class="w-full" label=""
                                val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </vs-td>

                    <vs-td :data="data[indextr].vat">
                      <ValidationProvider :vid="indextr+'vat'" :name="indextr+'vat'" rules="required" v-slot="{ errors }">
                        <vs-input v-model="data[indextr].vat"  name="vat" class="w-full" label=""
                                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </vs-td>

                    <vs-td :data="data[indextr].unit_price">
                      {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                    </vs-td>

                    <vs-td :data="data[indextr].id">
                      <vx-tooltip class="" text="Remove from cart" position="left">
                        <vs-button @click="onClickRemoveFromCart(indextr)"
                                    size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                      </vx-tooltip>
                    </vs-td>

                  </vs-tr>
                </template>
              </vs-table>
              <vx-card no-shadow class="mt-10">
                <span>
                  <div class="mb-3 vx-row">
                    <div class="vx-col">
                       <h3>Additional Cost</h3>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="w-full vx-col">
                      <vs-button color="success" size="small" type="border" @click="addCost">Add</vs-button>
                    </div>
                  </div>
                  <div class="mt-4 mb-3 vx-row" v-for="(additional_cost, index) in additional_costs" :key="additional_cost.id">
                      <div class="w-full vx-col md:w-1/4 md:mb-0">
                        <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                          <small class="label">Name</small>
                          <vs-input v-model="additional_cost.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </div>
<!--                      <div class="w-full vx-col md:w-1/4 md:mb-0">-->
<!--                        <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">-->
<!--                          <small class="label">Type</small>-->
<!--                          <v-select :clearable="false" name="type" placeholder="Select Cost Type" v-model="additional_cost.type"-->
<!--                              :options="types" />-->
<!--                          <span class="text-sm text-danger">{{ errors[0] }}</span>-->
<!--                        </ValidationProvider>-->
<!--                      </div>-->
                      <div class="w-full vx-col md:w-1/4 md:mb-0">
                        <ValidationProvider vid="amount" name="amount" rules="required" v-slot="{ errors }">
                          <small class="label">Amount (GBP)</small>
                          <vs-input v-model="additional_cost.amount"  name="amount" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </div>
                    <div class="w-full vx-col md:w-1/4 md:mb-0">
                        <ValidationProvider vid="amount" name="vat" rules="required" v-slot="{ errors }">
                          <small class="label">Vat (GBP)</small>
                          <vs-input v-model="additional_cost.vat"  name="vat" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </div>
                      <div class="w-50 vx-col md:w-1/4 md:mb-0">
                        <vs-button @click="deleteCost(index)" class="mt-8 ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                      </div>
                  </div>
                </span>
              </vx-card>
            </div>
            <div class="w-full vx-col md:mb-0">
              <div class="w-full vx-col md:mb-0">
                <vx-card no-shadow>
                <span>
                  <div v-if="!id" class="mb-3 vx-row">
                    <div class="w-full vx-col md:w-full md:mb-0">
                      <ValidationProvider vid="category_id" name="category_id" rules="required" v-slot="{ errors }">
                        <small class="label">Supplier</small>
                        <v-select @search="onSearch" name="user_group" :reduce="option => option.id" v-model="form.supplier_id" label="company_name"
                                  :closeOnSelect="true" :options="other_supplies" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                          <template slot="no-options">
                            type to search supplier
                          </template>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="mb-3 vx-row">
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                        <small class="label">Address Line 1</small>
                        <vs-input v-model="form.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                        <small class="label">Address Line 2</small>
                        <vs-input v-model="form.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>

                  <div class="mb-3 vx-row">
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                        <small class="label">Address Line 3</small>
                        <vs-input v-model="form.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                        <small class="label">Town / State</small>
                        <vs-input v-model="form.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>

                  <div class="mb-3 vx-row">
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                        <small class="label">Postal Code</small>
                        <vs-input v-model="form.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                        <small class="label">Country</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                                label="name" v-model="form.country" :reduce="option => option.name"
                                :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-sm text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/3 w-full md:mb-0">
                      <ValidationProvider vid="sage_department" name="sage_department" rules="required" v-slot="{errors}">
                        <small class="label">Sage Department</small>
                          <v-select :filter-by="myFilter" :clearable="false" name="sage_department" placeholder=""
                                    label="name" v-model="form.sage_department_id" :reduce="option => option.id"
                                    :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                          <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/3 w-full md:mb-0">
                    <ValidationProvider vid="region" name="region" rules="required" v-slot="{errors}">
                      <small class="label">Region</small>
                        <v-select :filter-by="myFilter" :clearable="false" name="region" placeholder=""
                                  label="name" v-model="form.region_id" :reduce="option => option.id"
                                  :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                   </div>
                    <div class="vx-col md:w-1/3 w-full md:mb-0">
                    <ValidationProvider vid="required_by" name="required_by" rules="required" v-slot="{ errors }">
                        <small class="label">Required By Date</small>
                        <flat-pickr class="w-full"
                                    style="display: none"
                                    :config="{ dateFormat: 'd/m/Y'}"
                                    v-model="form.required_by"
                                    placeholder="Choose Date"
                        />
                        <flat-pickr class="w-full"
                                    :config="{ dateFormat: 'd/m/Y'}"
                                    v-model="form.required_by"
                                    placeholder="Choose Date"
                        />
                      <span class="text-sm text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                   </div>
                 </div>
                </span>

                  <div class="mb-3 vx-row">
                    <div class="w-full vx-col">
                      <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                        <small class="label">Delivery Instructions</small>
                        <vs-textarea class="mb-0" v-model="form.delivery_instruction" height="80px" />
                        <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="mb-3 vx-row">
                    <div class="w-full vx-col">
                      <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                        <small class="label">Special Note</small>
                        <vs-textarea class="mb-0" v-model="form.note" height="120px" />
                        <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Order</vs-button>
            <vs-button @click="open =false" class="mt-2 ml-4" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const OtherSupplierRepository = RepositoryFactory.get('other_supplier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const SettingsRepository = RepositoryFactory.get('settings');
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');
  const RegionsRepository = RepositoryFactory.get('regions');
  const DropDownRepository = RepositoryFactory.get('drop_down');
  const CompanyAddressRepository = RepositoryFactory.get('company_address');


  import { XIcon } from 'vue-feather-icons'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'
  import SageFactory from "@/mixins/SageFactory";

  function initialState() {
    return {
      open: false,
      id: '',
      countryCodes: [],
      form: {
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction: '',
        note: '',
        order_items: [],
        additional_cost: [],
        required_by:'',
      },
      isCreateFromMainMenu: false,
      cartItems: [],
      additional_costs: [],
      types: [ 'percent', 'sum', 'subtract' ],
      other_supplies: [],
      sage_departments:[],
      regions:[],
    }
  }

export default {
  name: 'OtherSupplierOrderPopUp',
  props: {
    cartItems: {
      type: Array,
    }
  },
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id = null) {
      try {
        Object.assign(this.$data, initialState())
        this.cartItems = this.cartItems.map((item) => {
          item.vat = 0
          return item
        })
        this.open = true;
        await this.fetchCountryCodes()
        await this.getSageDepartments()
        await this.getRegions()
        await this.fetchSettings()

        this.id = id
      } catch (error) {
      }
    },
    async fetchCountryCodes() {
      await this.$vs.loading({
        container: '#create-order-popup',
        scale: 0.45
      })
      try {
        this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
      } catch (e) {
        this.convertAndNotifyError(e)
        this.open = false
      }
      this.$vs.loading.close('#create-order-popup > .con-vs-loading')
    },
    async fetchSettings(){
      await this.$vs.loading({
        container: '#create-order-popup',
        scale: 0.45
      })
      try {
        const settings = (await SettingsRepository.getTheItem('order_delivery_instructions')).data.data
        this.form.delivery_instruction = settings.order_delivery_instructions

        const { data: addresses } = (await CompanyAddressRepository.getCompanyAddresses('filter[is_default]=1')).data
        const defaultAddress = addresses[0]
        if (defaultAddress) {
          this.form.line1 = defaultAddress.line1 || ''
          this.form.line2 = defaultAddress.line2 || ''
          this.form.line3 = defaultAddress.line3 || ''
          this.form.town_state = defaultAddress.town_state || ''
          this.form.post_code = defaultAddress.post_code || ''
          this.form.country = defaultAddress.country || ''
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-order-popup > .con-vs-loading')
    },
    async getSageDepartments(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
      this.sage_departments =  data.data
      this.$vs.loading.close()
    },
    async getRegions(){
      this.$vs.loading()
      const {data} = await RegionsRepository.getListOfRegions()
      this.regions =  data.data
      this.$vs.loading.close()
    },
    async onClickClose() {
      const vue = this;
      this.open = false
    },
    async onClickCreateServiceOrder () {
      const vue = this;
      await this.$vs.loading({
        container: '#create-order-popup',
        scale: 0.45
      })
       try {
        if(this.id) {
          this.form.supplier_id = this.id
        }
        this.form.order_items = this.cartItems.map((n) => {
          n.unit_price = Number(n.unit_price).toFixed(2)
          n.vat = Number(n.vat).toFixed(2)
          delete n.category
          delete n.name
          return n
        })

        this.form.additional_cost = this.additional_costs.map((n) => {
          n.amount = Number(n.amount).toFixed(2)
          n.vat = Number(n.vat).toFixed(2)
          return n
        })

        const response = (await OtherSupplierRepository.createSupplierServicesOrder(this.form)).data.data
        //  if(response.other_supplier_sage_id === ""){
        //    this.open = false
        //    const text = `The following supplier(s) is not set up on Sage.you will need to manually synchronise
        //                   all orders from this purchase OR activate that supplier in Sage. Order ID:${response.order_code}`
        //    this.$vs.dialog({
        //      type: 'confirm',
        //      color: 'warning',
        //      title: 'Note',
        //      acceptText: 'OK',
        //      text: text,
        //      cancel: this.closeUpdate
        //    })
        //  }else{
        //    await this.createSageOtherServiceOrder(response)
        //  }
        this.showSuccessMessage('Service order created successfully')
        this.open = false;
        await vue.$parent.refreshData()
       }catch (e) {
        this.convertAndNotifyError(e)
       }
      this.$vs.loading.close('#create-order-popup > .con-vs-loading')
    },
    addCost(){
      this.additional_costs.push({ name: '',amount:'', vat: '' });
    },
     deleteCost: function (index) {
       this.additional_costs.splice(index, 1);
    },
    async onClickRemoveFromCart(index) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        // const search = this.cartItems.find((n) => n.other_supplier_service_id === id )
        // this.cartItems = this.cartItems.filter(element => element !== search);
        this.cartItems.splice(index, 1)
        this.showSuccessMessage('Removed from cart')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce( async (loading, search, vm) => {
      const {data} = (await DropDownRepository.getOtherSupplierList(`filter[search]=${encodeURIComponent(search)}`)).data
      vm.other_supplies = data
      loading(false);
    }, 350),
  },
  async mounted () {

  },
  computed: {

  },
  components: {
    'v-select': vSelect,
    XIcon,
    flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages, SageFactory],
}
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    /*min-height: 80% !important;*/
    min-width: 80% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
